import React, { PureComponent } from 'react';
import { View, SectionList, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';
import { DRNTextInputHeader } from '@traveloka/district-ui';

import AutoCompleteItem from './AutoCompleteItem';
import AutoCompleteSectionHeader from './AutoCompleteSectionHeader';

import noOp from 'common/utils/noOp';

import R from 'common/res/R';

class AutoComplete extends PureComponent {
  static Item = AutoCompleteItem;
  static SectionHeader = AutoCompleteSectionHeader;

  static propTypes = {
    headerProps: PropTypes.shape({}).isRequired,
  };

  static defaultProps = {
    onItemPressed: noOp,
  };

  renderSectionHeader = ({ section }) => (
    <AutoCompleteSectionHeader key={section.label} title={section.label} />
  );

  renderItem = ({ item, section }) => (
    <AutoCompleteItem
      key={`${section.label}-${item.code}`}
      item={item}
      onPress={this.props.onItemPressed}
    />
  );

  render() {
    const {
      headerProps,
      renderSectionHeader,
      renderItem,
      ...restProps
    } = this.props;

    return (
      <View style={styles.container}>
        <DRNTextInputHeader autoFocus {...headerProps} />
        <SectionList
          renderSectionHeader={renderSectionHeader || this.renderSectionHeader}
          renderItem={renderItem || this.renderItem}
          {...restProps}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: R.color.uiLightPrimary,
  },
});

export default AutoComplete;
